import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { Product } from '../../../products/models/products.types';
import { AccordionModule } from 'primeng/accordion';
import { CommonModule } from '@angular/common';
import { Solution } from '../../models/solutions.types';
import { BadgeCheck, ChevronRight, LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-solution-card',
  imports: [AccordionModule, CommonModule, LucideAngularModule],
  templateUrl: './solution-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolutionCardComponent {
  readonly solution = input.required<Solution>();
  readonly products = input.required<Product[]>();

  readonly chevronRight = ChevronRight;
  readonly badge = BadgeCheck;

  private readonly openIds = signal<Set<string>>(new Set());

  protected toggle(id: string): void {
    this.openIds.update(set => {
      const newSet = new Set(set);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  }

  isOpen(id: string): boolean {
    return this.openIds().has(id);
  }
}
